import debounce from 'lodash/debounce';
import { useState, useCallback } from 'react';
export const useDebouncedState = (value, delay = 200) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const setValDebounced = useCallback(debounce(setDebouncedValue, delay), [delay]);
    return [debouncedValue, setValDebounced];
};
